<div class="mp">
  <div class="mp-header">
    <div>
      <h3 class="mp-title">Manage Plans</h3>
      <p class="mp-subtitle">Compare plans and choose the right fit for your restaurant.</p>
    </div>
    <button type="button" class="mp-kebab" (click)="close()" aria-label="Close">
      <i class="bx bx-x"></i>
    </button>
  </div>

  <div class="mp-legend">
    <i class="bx bx-info-circle"></i>
    @if (canManagePlans) {
      <span
        >Upgrades take effect immediately. Downgrades take effect at the end of your billing
        period.</span
      >
    } @else {
      <span>Plan changes will be available once your restaurant is fully activated.</span>
    }
  </div>

  <div mat-dialog-content class="mp-content">
    <div class="mp-grid" [style.--mp-cols]="plans.length">
      @for (plan of plans; track plan.name) {
        <div class="mp-plan-wrap" [class.mp-plan-wrap--recommended]="plan.isRecommended">
          @if (plan.isRecommended) {
            <span class="mp-badge-recommended">
              <i class="bx bxs-star"></i>
              RECOMMENDED
            </span>
          }
          <div
            class="mp-plan"
            [class.mp-plan--active]="plan.isActive"
            [class.mp-plan--recommended]="plan.isRecommended"
          >
            <div class="mp-plan-head">
              <span class="mp-plan-name">{{ plan.name }}</span>
              @if (plan.isActive) {
                <span class="sub-pill sub-pill--success"
                  ><span class="sub-pill-dot"></span>Your plan</span
                >
              }
            </div>
            <p class="mp-plan-desc">{{ plan.description }}</p>

            <div class="mp-plan-price-row">
              @if (plan.originalPrice) {
                <span class="mp-plan-price-strike"
                  >{{ getCurrencySymbol(currency) }}{{ plan.originalPrice.toFixed(2) }}</span
                >
              }
              <span class="mp-plan-price">{{ plan.priceLabel.amount }}</span>
              @if (plan.priceLabel.suffix) {
                <span class="mp-plan-price-suffix">{{ plan.priceLabel.suffix }}</span>
              }
            </div>
            @if (plan.priceLabel.detail) {
              <p class="mp-plan-price-detail">{{ plan.priceLabel.detail }}</p>
            }

            <div class="custom-line-bottom my-3"></div>

            @if (plan.promo) {
              <div class="mp-info-banner mp-promo">
                <span class="mp-info-icon"><i class="bx bx-info-circle"></i></span>
                <div>
                  <div class="mp-info-title">{{ plan.promo.title }}</div>
                  <div class="mp-info-text">{{ plan.promo.text }}</div>
                </div>
              </div>
            }

            @if (plan.previousPlanName) {
              <div
                class="mp-everything-in"
                [class.mp-everything-in--recommended]="plan.isRecommended"
              >
                Everything in {{ plan.previousPlanName }}, plus:
              </div>
            }

            <ul class="mp-feature-list mp-feature-list--flush">
              @for (feature of plan.features; track feature) {
                <li>
                  <i
                    class="bx bx-check-circle"
                    [class.mp-check--recommended]="plan.isRecommended"
                    [class.mp-check--active]="plan.isActive"
                  ></i>
                  <span>{{ feature }}</span>
                </li>
              }
            </ul>

            @if (plan.isActive) {
              <!-- A status, not an action: a disabled button here read like a
                   control that wasn't working. -->
              <div class="mp-current-plan" role="status">
                <i class="bx bxs-check-circle"></i>
                <span>
                  You're on this plan
                  @if (hasPendingDowngrade && downgradeEffectiveLabel) {
                    <span class="mp-current-plan-until">until {{ downgradeEffectiveLabel }}</span>
                  }
                </span>
              </div>
            } @else if (!canManagePlans) {
              <!-- Not activated yet: a disabled "Upgrade" button looked clickable. -->
              <div class="mp-current-plan mp-current-plan--locked" role="status">
                <i class="bx bx-lock-alt"></i>
                <span>Available after activation</span>
              </div>
            } @else {
              <button
                type="button"
                class="sub-btn mp-plan-btn"
                [class.sub-btn--dark]="plan.buttonStyle === 'dark'"
                [class.sub-btn--outline]="plan.buttonStyle === 'outline'"
                [class.sub-btn--downgrade]="plan.buttonStyle === 'downgrade'"
                [disabled]="plan.buttonDisabled"
                (click)="selectPlan(plan)"
              >
                {{ plan.buttonLabel }}
              </button>
            }
            @if (plan.isPendingTarget) {
              <div class="mp-timing-note">
                <i class="bx bx-calendar"></i>
                Switching
                {{ downgradeEffectiveLabel ? 'on ' + downgradeEffectiveLabel : 'at period end' }}
              </div>
            } @else if (plan.timing && canManagePlans) {
              <div class="mp-timing-note">
                <i class="bx bx-bolt-circle"></i>
                @if (plan.timing === 'upgrade') {
                  {{
                    plan.prorated ? 'Applies immediately · prorated today' : 'Applies immediately'
                  }}
                } @else {
                  {{
                    downgradeEffectiveLabel
                      ? 'Applies on ' + downgradeEffectiveLabel
                      : 'Applies at the end of your billing period'
                  }}
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
